/* eslint-disable react/prop-types -- Native input props are checked by TypeScript. */
import React from 'react';

// Deliberately local to Lease Records: shared application inputs keep their behavior.
const LeaseRecordInput = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
    ({ onChange, onBlur, type = 'text', ...props }: React.InputHTMLAttributes<HTMLInputElement>, ref) => (
        <input
            {...props}
            ref={ref}
            type={type}
            onChange={onChange}
            onBlur={(event) => {
                if (['text', 'search', 'email', 'tel', 'url'].includes(type) && !props.readOnly && !props.disabled) {
                    const trimmed = event.currentTarget.value.trim();
                    if (trimmed !== event.currentTarget.value) {
                        event.currentTarget.value = trimmed;
                        onChange?.(event);
                    }
                }
                onBlur?.(event);
            }}
        />
    )
);

LeaseRecordInput.displayName = 'LeaseRecordInput';
export default LeaseRecordInput;



// WEBPACK FOOTER //
// ./src/components/leases/LeaseRecordInput.tsx